export interface ProjectAdminMenuItem {
  label: string;
  value: string;
  type: ProjectAdminMenuType;
  sequenceOrder: number;
}

export enum ProjectAdminMenuType {
  GENERAL = 'GENERAL',
  USER_ADMIN = 'USER_ADMIN',
  MODULES = 'MODULES',
  WORK_PACKAGES = 'WORK_PACKAGES',
  QUANTITY_REPORTING = 'QUANTITY_REPORTING',
  WELD_SETUP = 'WELD_SETUP',
  ROD_ROOMS = 'ROD_ROOMS',
  SYNC = 'SYNC',
  FEATURES = 'FEATURES',
  DATA_VAULT = 'DATA_VAULT',
  REPORT = 'REPORT',
}

export interface ProjectAdminListProps {
  isListCollapsed: boolean;
  onToggleCollapse: () => void;
}
